import {useMemo} from "react";

export const useBreakpoints = () => {
  return useMemo(() => {
    return {
      isMobile: window.innerWidth < 1024,
    }
  }, [window.innerWidth])
}